import { createApiAction, restApiActions } from 'redux/redux-actions';

import restApis from '../restApis';
import {
  WITHDRAW_CREDITS,
  PURHCASE_CREDITS,
  TRANSFER_CREDITS,
} from '../constants';

const withdrawCreditsApi = restApis('credits/withdraw').create;
const purchaseCreditsApi = restApis('credits/purchase').create;
const transferCreditsApi = restApis('credits/transfer').create;

export const withdrawCredits = createApiAction(WITHDRAW_CREDITS, withdrawCreditsApi);
export const purchaseCredits = createApiAction(PURHCASE_CREDITS, purchaseCreditsApi);
export const transferCredits = createApiAction(TRANSFER_CREDITS, transferCreditsApi);

export default restApiActions('credits');
